module.exports = __webpack_public_path__ + "static/media/home-background.c92b9415.gif";